import * as React from "react";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTheme } from "@emotion/react";
import { Box } from "@mui/material";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.secondary.main,
      },
    },
    "&.Mui-disabled": {
      "& + .MuiSwitch-track": {
        backgroundColor: "grey", // Change track color when disabled
        opacity: 0.5,
      },
      "& .MuiSwitch-thumb": {
        color: "lightgrey", // Change thumb color when disabled
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

const ToggleButton = ({
  label,
  type,
  value,
  isRequired = false,
  isDisabled = false,
  onChange,
  componentId,
  categoryId,
}) => {
  const theme = useTheme();
  return (
    <Box
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          fontSize: theme.size[14],
          fontWeight: theme.fontWeight[500],
          marginRight: theme.size[8],
        }}
      >
        {label}
      </Typography>

      <AntSwitch
        checked={value === "Yes"}
        disabled={isDisabled}
        onChange={(e) => {
          onChange(categoryId, componentId, e.target.checked ? "Yes" : "No");
        }}
        inputProps={{ "aria-label": "ant design" }}
      />
    </Box>
  );
};

export default ToggleButton;
